
import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Button,
    Form,
    Input,
    Label,
    Alert,
    FormFeedback
} from "reactstrap"
import { connect } from "react-redux"
import { useFormik } from "formik"
import * as Yup from "yup"
import { setBreadcrumbItems } from "../../store/actions"
import { get, post } from "../../helpers/api_helper"

const CompanySettings = (props) => {
    document.title = "Paramètres de l'entreprise | CRM";

    const [imgStore, setImgStore] = useState(null);
    const [logoPreview, setLogoPreview] = useState(null);

    // Get Storage Base URL with fallback
    const getStorageUrl = () => {
        if (process.env.REACT_APP_STORAGE_URL) return process.env.REACT_APP_STORAGE_URL;
        const apiUrl = process.env.REACT_APP_API_URL || "https://serv.business.rakopssolutions.com/api";
        return apiUrl.replace("/api", "") + "/storage";
    };
    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [loading, setLoading] = useState(false);

    const breadcrumbItems = [
        { title: "CRM", link: "#" },
        { title: "Paramètres", link: "#" },
        { title: "Entreprise", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Paramètres de l'entreprise", breadcrumbItems)
        fetchCompanyData()
    }, [])

    const fetchCompanyData = async () => {
        try {
            const response = await get("/company-settings")
            if (response) {
                validation.setValues({
                    name: response.name || "",
                    email: response.email || "",
                    phone: response.phone || "",
                    secondary_phone: response.secondary_phone || "",
                    address: response.address || "",
                    city: response.city || "",
                    state: response.state || "",
                    country: response.country || "",
                    postal_code: response.postal_code || "",
                    tax_id: response.tax_id || "",
                    vat_number: response.vat_number || "",
                    business_registration_number: response.business_registration_number || "",
                    website: response.website || "",
                    timezone: response.timezone || "UTC",
                    currency: response.currency || "MAD",
                });
                console.log("Response from /company-settings:", response);
                if (response.logo) {
                    const fullLogoUrl = getStorageUrl() + "/" + response.logo.replace("logos/", "logos/"); // Ensure path
                    console.log("Setting logo preview to:", fullLogoUrl);
                    setLogoPreview(fullLogoUrl);
                }
            }
        } catch (error) {
            setErrorMsg("Erreur lors de la récupération des données.");
        }
    }

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: "",
            email: "",
            phone: "",
            secondary_phone: "",
            address: "",
            city: "",
            state: "",
            country: "",
            postal_code: "",
            tax_id: "",
            vat_number: "",
            business_registration_number: "",
            website: "",
            timezone: "UTC",
            currency: "MAD",
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Nom de l'entreprise requis"),
            email: Yup.string().email("Email invalide").required("Email requis"),
        }),
        onSubmit: async (values) => {
            setLoading(true);
            setErrorMsg("");
            setSuccessMsg("");

            const formData = new FormData();
            Object.keys(values).forEach(key => {
                if (values[key] !== null && values[key] !== undefined) {
                    formData.append(key, values[key]);
                }
            });

            if (imgStore) {
                formData.append("logo", imgStore);
            }

            try {
                const response = await post("/company-settings", formData, {
                    headers: { "Content-Type": "multipart/form-data" }
                });
                setSuccessMsg(response.message);
                if (response.company && response.company.logo) {
                    const fullLogoUrl = getStorageUrl() + "/" + response.company.logo;
                    setLogoPreview(fullLogoUrl);
                }
                setTimeout(() => setSuccessMsg(""), 5000);
            } catch (error) {
                setErrorMsg(error.response?.data?.message || "Erreur lors de la mise à jour.");
            } finally {
                setLoading(false);
            }
        },
    })

    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImgStore(file);
            setLogoPreview(URL.createObjectURL(file));
        }
    };

    return (
        <React.Fragment>
            <Row>
                <Col lg="12">
                    <Card>
                        <CardBody>
                            <CardTitle className="h4 mb-4">Informations de l'Entreprise</CardTitle>

                            {successMsg && <Alert color="success" fade={false}>{successMsg}</Alert>}
                            {errorMsg && <Alert color="danger" fade={false}>{errorMsg}</Alert>}

                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    validation.handleSubmit();
                                    return false;
                                }}
                            >
                                <Row>
                                    <Col md={3} className="text-center mb-4">
                                        <div className="mb-3">
                                            <Label>Logo de l'entreprise</Label>
                                            <div className="mt-2">
                                                {logoPreview ? (
                                                    <img src={logoPreview} alt="Logo" className="img-thumbnail rounded-circle mb-3" style={{ width: "150px", height: "150px", objectFit: "cover" }} />
                                                ) : (
                                                    <div className="bg-light rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" style={{ width: "150px", height: "150px" }}>
                                                        <i className="mdi mdi-office-building text-muted" style={{ fontSize: "50px" }}></i>
                                                    </div>
                                                )}
                                                <div className="mt-2">
                                                    <Input
                                                        type="file"
                                                        id="logo-upload"
                                                        className="d-none"
                                                        accept="image/*"
                                                        onChange={handleLogoChange}
                                                    />
                                                    <Button
                                                        color="primary"
                                                        outline
                                                        onClick={() => document.getElementById('logo-upload').click()}
                                                    >
                                                        Choisir un logo
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>

                                    <Col md={9}>
                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label>Nom de l'entreprise</Label>
                                                    <Input
                                                        name="name"
                                                        type="text"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.name}
                                                        invalid={validation.touched.name && validation.errors.name ? true : false}
                                                    />
                                                    {validation.touched.name && validation.errors.name ? (
                                                        <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                                                    ) : null}
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label>Email Professionnel</Label>
                                                    <Input
                                                        name="email"
                                                        type="email"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.email}
                                                        invalid={validation.touched.email && validation.errors.email ? true : false}
                                                    />
                                                    {validation.touched.email && validation.errors.email ? (
                                                        <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                                    ) : null}
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label>Téléphone principal</Label>
                                                    <Input
                                                        name="phone"
                                                        type="text"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.phone}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label>Téléphone secondaire</Label>
                                                    <Input
                                                        name="secondary_phone"
                                                        type="text"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.secondary_phone}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <Label>Adresse</Label>
                                                    <Input
                                                        name="address"
                                                        type="textarea"
                                                        rows="2"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.address}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <Label>Ville</Label>
                                                    <Input
                                                        name="city"
                                                        type="text"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.city}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <Label>Code Postal</Label>
                                                    <Input
                                                        name="postal_code"
                                                        type="text"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.postal_code}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <Label>Pays</Label>
                                                    <Input
                                                        name="country"
                                                        type="text"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.country}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>

                                        <hr className="my-4" />
                                        <h5 className="mb-3">Informations Fiscales & Identifiants</h5>

                                        <Row>
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <Label>IF (Identifiant Fiscal)</Label>
                                                    <Input
                                                        name="tax_id"
                                                        type="text"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.tax_id}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <Label>ICE (ou TVA)</Label>
                                                    <Input
                                                        name="vat_number"
                                                        type="text"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.vat_number}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <Label>RC (Registre Commerce)</Label>
                                                    <Input
                                                        name="business_registration_number"
                                                        type="text"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.business_registration_number}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label>Site Web</Label>
                                                    <Input
                                                        name="website"
                                                        type="text"
                                                        placeholder="https://example.com"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.website}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div className="mb-3">
                                                    <Label>Devise</Label>
                                                    <Input
                                                        name="currency"
                                                        type="select"
                                                        className="form-select"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.currency}
                                                    >
                                                        <option value="MAD">MAD (Dirham)</option>
                                                        <option value="EUR">EUR (€)</option>
                                                        <option value="USD">USD ($)</option>
                                                    </Input>
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div className="mb-3">
                                                    <Label>Fuseau horaire</Label>
                                                    <Input
                                                        name="timezone"
                                                        type="text"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.timezone}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>

                                        <div className="mt-4 text-end">
                                            <Button
                                                type="submit"
                                                color="success"
                                                className="px-5 py-2 fw-bold"
                                                disabled={loading}
                                            >
                                                {loading ? "Mise à jour en cours..." : "Enregistrer les modifications"}
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(CompanySettings)
